module.exports = __webpack_public_path__ + "img/236.desk.696fc539.svg";